import React from 'react';
import * as UI from './styles';

export interface IDividerProps {
  w?: number | string;
  h?: number | string;
}

function Divider({ w = '6rem', h = 0 }: IDividerProps) {
  return <UI.Container w={w} h={h} />;
}

export default Divider;
